var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronTop = function SvgChevronTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.705 10.775 9.06 3.945a1.5 1.5 0 0 0-2.12 0l-6.65 6.83a1 1 0 0 0 0 1.43 1 1 0 0 0 1.415 0L8 5.73l6.295 6.5a1 1 0 0 0 1.41 0 1 1 0 0 0 0-1.455Z"
  })));
};
export default SvgChevronTop;